document.addEventListener("DOMContentLoaded", function () {
  // Function to fetch cart data and update the subtotal display
  function updateCartSubtotal() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Select the element using the data attribute already on your HTML
        const subtotalElement = document.querySelector('[data-cart-subtotal]');
        if (subtotalElement) {
          // Convert total_price (which is in cents) to dollars and update the text
          subtotalElement.innerText = `SUBTOTAL: ₹${(cart.total_price / 100).toFixed(2)}`;
        }
      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  // Update subtotal on page load
  updateCartSubtotal();

  // Watch for changes within the cart drawer (for example, when items are added or removed)
  const cartDrawer = document.querySelector('.cart__drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(updateCartSubtotal);
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Listen for clicks on common cart update elements to refresh the subtotal
  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".cart-update, .remove-item, .quantity-input")) {
      // Allow a short delay for Shopify to update the cart before refreshing the subtotal
      setTimeout(updateCartSubtotal, 500);
    }
  });
});
